import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable()
export class PipelineService {

    baseurl = environment.apiBaseUrl;

    constructor(protected http: HttpClient) {
    }

    getPipelines(materialName: any[]) {
        return this.http.get<any[]>(this.baseurl + 'pipeline/getpipelines/' + materialName);
    }

    getSites() {
        return this.http.get<any[]>(this.baseurl + 'site/sitesandprovince');
    }

    getMaterials() {
        return this.http.get<any[]>(this.baseurl + 'material/getIndustrialGases');
    }

    getUoms() {
        return this.http.get<any[]>(this.baseurl + 'pipeline/getindustrialgasuoms');
    }

    getSuppliers() {
        return this.http.get<any[]>(this.baseurl + 'pipeline/getsuppliers');
    }

    addPipeline(pipeline: any) {
        return this.http.post<any[]>(this.baseurl + 'pipeline/addpipeline', pipeline)
    }

    updatepiPeline(pipeline: any) {
        return this.http.post<any[]>(this.baseurl + 'pipeline/updatepipeline', pipeline)
    }
}